
export const routes = (prefix = `master-data`) => [
    {
        path: `/${prefix}/accounts/item-categories`,
        name: `${prefix}.item-categories.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.accounts.item-categories.index`,
                PageDescription: "Accounts master data: Item categories",
            },
        },
    },
];
